import React from 'react';
import Icon from '../../../../components/icon/Icon';
import Image from '../../../../components/image/Image';

import './ProjectInfoBox.scss';

interface Props {
  img?: string;
  name?: string;
  number?: string;
  area?: string;
}

const ProjectInfoBox: React.FC<Props> = ({ img, name, number, area }) => {
  return (
    <div className="project-info-box">
      <div className="project-info-box__image">
        {img ? <Image src={img} alt="project info image" /> : <Icon size="full-size" icon="projectsRed" className="project info icon" />}
      </div>
      <div className="project-info-box__info">
        <div className="project-info-box__name">{name}</div>
        <div className="project-info-box__bottom">
          <div className="project-info-box__number">{number}</div>
          <div className="project-info-box__area">{area}</div>
        </div>
      </div>
    </div>
  );
};

export default ProjectInfoBox;
